import { Avatar, Collapse, Stack, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import { AnswersUserProps } from "../../../presenter/useAnswers";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import dayjs from "dayjs";

export type UserCardProps = AnswersUserProps & {
  children: React.ReactNode;
};

export const UserCard = ({
  id,
  name,
  position,
  photo,
  children,
  endTime,
}: UserCardProps) => {
  const theme = useTheme();
  const [isOpen, setOpen] = useState<boolean>(false);
  const dateColor =
    theme.palette.mode === "dark" ? theme.palette.text.secondary : "#666666";

  const toggleOpen = () => {
    setOpen((prev) => !prev);
  };
  return (
    <Stack borderBottom={`1px solid ${theme.palette.divider}`}>
      <Stack
        py={1.5}
        px={1}
        display="flex"
        flexDirection="row"
        flexWrap="wrap"
        alignItems="center"
        gap={2}
        onClick={toggleOpen}
        sx={{
          cursor: "pointer",
          transition: "background-color 0.2s ease",
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        }}
        role="button"
      >
        <Avatar
          sx={{ width: "50px", height: "50px" }}
          alt="User Avatar"
          src={photo}
        />
        <Stack flexGrow={1}>
          <Stack fontSize={13} color={dateColor}>
            {dayjs(endTime).format("DD.MM.YYYY HH:mm")}
          </Stack>
          <Stack spacing={1.5}>
            <Stack
              lineHeight={1}
              display="flex"
              alignItems="center"
              flexDirection="row"
              gap={2}
            >
              <Typography variant="body2">{name}</Typography>
              <Typography variant="subtitle2" color="#579CFF">
                ({position})
              </Typography>
              <Stack
                marginLeft="auto"
                flexShrink={0}
                sx={{
                  transition: "transform 0.3s ease",
                  transform: isOpen ? "rotateX(180deg)" : "rotate(0deg)",
                }}
              >
                <KeyboardArrowDownIcon />
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
      <Collapse in={isOpen}>{children}</Collapse>
    </Stack>
  );
};
